export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_IRIS_CLIENT_ID_DEV_PROD,
    authority: process.env.VUE_APP_IRIS_AUTHORITY_DEV_PROD,
    redirectUri: process.env.VUE_APP_IRIS_REDIRECT_URI_DEV_PROD
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
}
